import { useEffect, useState } from "react";

// Reactive CSS media-query hook. The app styles inline (no stylesheet/media
// queries), so responsive layouts branch on this at render time.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

// Shared breakpoint for "stack everything" — phones and narrow windows.
export const MOBILE_QUERY = "(max-width: 760px)";
